import {IRootState} from "../reducers";

export const getConfirmModalOptions = (state: IRootState) =>
  state.messageBoxReducer.confirmModalOptions;
